import { createHTMLTransformer } from '@aeaton/prosemirror-transformers';
import { Node } from 'prosemirror-model';

import schema from '../schema';

const transformer = createHTMLTransformer(schema);

export const convertHtmlToDoc = (html?: string): Node | undefined => (html ? transformer.parse(html) : undefined);
